module.exports = __webpack_public_path__ + "assets/images/alipay.d79e72663bfa3f393d8cf1e9eed97271.svg";